import styled from "styled-components";

import { Default } from "Types";
import { typography } from "globalConstants";

export type PropsType = Default;

const Wrap = styled.div<Default>`
   border-radius: 50%;
   background-color: ${typography.other.color.gray[1]};
   width: 6px;
   height: 6px;
   ${({ css }) => css}
`;

export default function Dot(props: PropsType) {
   return <Wrap {...props}>{props.children}</Wrap>;
}
